<template>
  <div class="support-bar" v-if="!yunModel">
    <div class="item" @click="openSearchPage()">
      <div class="support_image">
        <i class="el-icon-search"></i>
      </div>
      <div class="desc">
        {{ $t("home.book") }}
      </div>
    </div>
    <div class="item item-add" @click="openKF5()">
      <div class="support_image">
        <i class="iconfont el-icon-eft-zaixiankefu-youcang"></i>
      </div>
      <div class="desc">
        {{ $t("side.service") }}
      </div>
    </div>
    <div class="item">
      <el-popover
        placement="left"
        width="340"
        trigger="hover"
        popper-class="popper-phone-400"
      >
        <div class="">
          <div>
            <i class="iconfont el-icon-eft-kefudianhua-youcang"></i
            >{{ $t("side.all") }}
          </div>
          <div class="desc all">400-666-9551</div>
          <div>{{ $t("side.every") }}</div>
          <div>
            {{ $t("side.north") }}<span class="desc">010-57168883</span>
          </div>
          <div>{{ $t("side.east") }}<span class="desc">021-58890585</span></div>
          <div>
            {{ $t("side.south") }}<span class="desc">020-66840326</span>
          </div>
        </div>
        <div slot="reference">
          <div class="support_image">
            <i class="iconfont el-icon-eft-kefudianhua-youcang"></i>
          </div>
          <div class="desc">
            {{ $t("side.Hotline") }}
          </div>
        </div>
      </el-popover>
    </div>
    <div class="item item-add">
      <el-popover
        placement="left-start"
        width="410"
        trigger="hover"
        popper-class="popper-weapp-logo"
      >
        <el-col :span="12">
          <p>{{ $t("side.weapp") }}</p>
          <div class="support_image">
            <img
              v-lazy="'//doc.yctop.com/yc/static/images/yc-we-app-code.jpg'"
            />
          </div>
        </el-col>
        <el-col :span="12">
          <p>{{ $t("side.public") }}</p>
          <div class="support_image">
            <img v-lazy="'//doc.yctop.com/yc/static/images/yc-wx-code.jpg'" />
          </div>
        </el-col>
        <el-row class="tc">
          <p>{{ $t("side.search") }}</p>
        </el-row>

        <div slot="reference">
          <div class="support_image">
            <i class="el-icon-eft-shouji iconfont"></i>
          </div>
          <div class="desc">
            {{ $t("side.mobile") }}
          </div>
        </div>
      </el-popover>
    </div>
    <transition name="el-zoom-in-top">
      <div class="item" v-show="show">
        <a
          class="support_image"
          href="javascript:void(0);"
          @click="backTopHandler"
        >
          <i class="iconfont el-icon-eft-zhiding-youcang"></i>
        </a>
      </div>
    </transition>
  </div>
  <div v-else></div>
</template>
<script>
(function() {
  if (window.KF5SupportBoxAPI) {
    console.log("客服组件已加载");
    return;
  }
  window.KF5SupportBoxAPI = null;
  var url =
      "https://assets-cdn.kf5.com/supportbox/main.js?" + new Date().getDay(),
    id = "kf5-provide-supportBox",
    charset = "utf-8";

  var script = document.createElement("script");
  script.type = "text/javascript";
  script.src = url;
  script.id = id;
  script.charset = charset;
  script.setAttribute("kf5-domain", "efreight.kf5.com");

  if (document.all) {
    script.onreadystatechange = function() {
      if (this.readyState == "loaded" || this.readyState == "complete") {
        console.log("loaded success in ie");
        initKF5();
      }
    };
  } else {
    script.onload = function() {
      initKF5();
    };
  }
  document.body.appendChild(script);

  function initKF5() {
    window.KF5SupportBoxAPI.init(); //ie11下无法自己初始化,
    window.KF5SupportBoxAPI.ready(function() {
      window.KF5SupportBoxAPI.removeButton();
    });
  }
})();

module.exports = {
  data: function() {
    return {
      title: "this is supportBar!",
      show: false,
      yunModel: this.$route.meta.yunModel
    };
  },
  methods: {
    backTopHandler: function() {
      window.scrollTo(0, 0);
    },
    openKF5: function() {
      if (window.KF5SupportBoxAPI) {
        window.KF5SupportBoxAPI.open();
      }
    },
    openSearchPage: function() {
      if (window.location.pathname != "/product/query") {
        this.$router.push({ name: "ProductQueryPage" });
      }
    }
  },
  mounted: function() {
    var screenHeight =
      window.document.documentElement.clientHeight ||
      window.document.body.clientHeight;
    var _this = this;
    window.onscroll = function(e) {
      var offsetY = window.document.documentElement.scrollTop;
      _this.show = offsetY > screenHeight * 1.5;
    };
  }
};
</script>
<style scoped>
@import "./index.css";
</style>
